import { ReactNode, memo, useEffect, useReducer } from 'react';
import { USER_PROFILE } from '../constant/storageKey';
import {
  UserProfileActionType,
  UserProfileContext,
  UserProfileDispatchContext,
  initialState,
  userReducer,
} from '../contexts/userProfileContext';
import { UserProfile } from '../types/user';
import { getUserProfile } from '../api/user';
import { walletAddress2UserId } from '../lib/utils';

interface IProps {
  children: ReactNode;
}

function createUserProfile(): UserProfile | null {
  try {
    const userProfile = localStorage.getItem(USER_PROFILE);
    if (userProfile) {
      const _userProfile = JSON.parse(userProfile);
      if (_userProfile?.access_token && _userProfile?.token_valid_until_ms > Date.now()) {
        return _userProfile;
      } else {
        localStorage.removeItem(USER_PROFILE);
      }
    }
  } catch {
    return null;
  }
  return null;
}

const UserProvider = ({ children }: IProps) => {
  const [userProfile, dispatch] = useReducer(userReducer, createUserProfile() ?? initialState);

  const url = new URL(window.location.href);

  const wallet = url.searchParams.get('wallet');

  useEffect(() => {
    if (wallet) {
      getUserProfile(walletAddress2UserId(wallet)).then((profile) => {
        dispatch({ type: UserProfileActionType.Update, payload: profile });
      });
    }
  }, [wallet]);

  return (
    <UserProfileContext.Provider value={userProfile}>
      <UserProfileDispatchContext.Provider value={dispatch}>
        {children}
      </UserProfileDispatchContext.Provider>
    </UserProfileContext.Provider>
  );
};

export default memo(UserProvider);
